import MemberCardComponent from './MemberCard'
import { BackgroundWrapper } from './MemberCard.styles'

const MemberCard = Object.assign(MemberCardComponent, { BackgroundWrapper })
export { MemberCard }
export type { MemberCardProps } from './MemberCard'
